// extracted by css-extract-rspack-plugin
export default {"list":"list-HUXNsg","item":"item-vz18Jz","header":"header-X4pRIY","titleLine":"titleLine-OlXJ19","name":"name-Ldbsxe","actions":"actions-soNb6G"};